import React, { useRef, useContext, useState, useEffect } from "react";

import capitalize from "../utils/capitalize";
import observer from "../utils/observer";
import Section from "../components/layout/Section/";
import Top from "./Home/Top";
import Focus from "./Home/Focus";
import Edito from "./Home/Edito";
import Dataviz from "./Home/Dataviz";
import Map from "./Home/Map";

const homeElements = ["top", "focus", "edito", "dataviz", "map"];

export default function Home() {
    const [sections, setSections] = useState(null);
    const [element, setElement] = useState(null);
    /*
    useEffect(() => {
        setSections(document.querySelectorAll(".anim"));
    }, []);
    
    sections &&
        sections.forEach((section) => {
            observer(onePage, updateOnePage).observe(section);
        });
    */
    return (
        <div id="home" className="container-fluid p-0">
            {homeElements?.length > 0 && homeElements.map((e) => {
                let component = require("./Home/" + capitalize(e)).default; 
                return component && (
                    <Section key={e} slug={e}>
                        {React.createElement(component)}
                    </Section>
                );
            })}
        </div>
    );
}
